import { Icon } from '@chakra-ui/react';

const CustomNoResultsIcon = (props) => {
  return (
    <Icon viewBox="0 0 55 55" fill="none" {...props}>
      <circle
        cx="27.5"
        cy="27.5"
        r="26"
        fill="white"
        stroke="#3A4A57"
        stroke-width="3"
      />
      <path
        d="M29.7199 29.9314C33.082 26.2926 33.082 20.3835 29.7199 16.7291C26.3578 13.0903 20.898 13.0903 17.5215 16.7291C14.1594 20.3679 14.1594 26.2771 17.5215 29.9314C20.8836 33.5702 26.3434 33.5702 29.7199 29.9314Z"
        stroke="#3A4A57"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M29.8049 30.3379L40.5808 42.0007"
        stroke="#3A4A57"
        stroke-width="3"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </Icon>
  );
};

export default CustomNoResultsIcon;
